import * as React from 'react';

interface DisplayBytesProps {
	bytes: number;
}

// https://stackoverflow.com/a/14919494/2249545
function humanFileSize(bytes: number, si: boolean = true) {
	const thresh = si ? 1000 : 1024;
	if (Math.abs(bytes) < thresh) {
		return bytes + ' B';
	}
	const units = si
		? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
		: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
	let u = -1;
	do {
		bytes /= thresh;
		++u;
	} while (Math.abs(bytes) >= thresh && u < units.length - 1);
	return bytes.toFixed(1) + ' ' + units[u];
}

/**
 * Displays a readable string of bytes, automatically modifying the suffix.
 *
 * @class DisplayBytes
 * @extends {React.PureComponent<DisplayBytesProps>}
 */
class DisplayBytes extends React.PureComponent<DisplayBytesProps> {
	public render() {
		return humanFileSize(this.props.bytes);
	}
}

export default DisplayBytes;
